<template>
  <el-select
    :value="value"
    :placeholder="$t('405')"
    :multiple="multiple"
    :clearable="clearable"
    :collapse-tags="collapseTags"
    @change="handlerChange"
  >
    <el-option v-for="item in stateArr" :key="item.key" :label="item.value" :value="item.key"> </el-option>
  </el-select>
</template>

<script>
// 获取在职状态
import { sysInfoFn } from 'api/org/per'
export default {
  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    collapseTags: {
      type: Boolean,
      default: false
    },
    value: {
      type: [Number, String, Array],
      default: ''
    }
  },
  data() {
    return {
      stateArr: [] // 可选项
    }
  },
  created() {
    this.sysInfoFn()
  },
  methods: {
    handlerChange(v) {
      // console.log(v)
      this.$emit('input', v)
    },
    // 获取在职状态
    async sysInfoFn() {
      const res = await sysInfoFn()
      this.stateArr = res.data.state
    }
  }
}
</script>

<style></style>
